import { useEffect, useState } from "react";
import API from "../api/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    API.get("/audit-logs").then((res) => setLogs(res.data));
  }, []);

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Auditlog</h1>
          <p className="page-subtitle">Recente systeemactiviteit en gebruikersacties.</p>
        </div>
      </header>

      <div className="list">
        {logs.map((log, i) => (
          <div key={i} className="list-row">
            <div>
              <div className="row-title">{log.action}</div>
              <div className="row-meta">{log.user} - {log.timestamp}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
